window.DEBUG=process.env.NODE_ENV!=="production";window.log=function(){var _console;if(DEBUG)(_console=console).log.apply(_console,arguments)};window.API_URL="https://www.kriptonite.com/"+window.LOCALE;window.px=function(x){return x+"px"};window.webglIsSupported=function(){try{var canvas=document.createElement("canvas");var ctx=window.WebGLRenderingContext;var webgl=canvas.getContext("webgl");var exp=canvas.getContext("experimental-webgl");return!!(ctx&&(webgl||exp))}catch(e){false}}();window.is_touch=function(){return"ontouchstart"in window||navigator.maxTouchPoints};


//////////////////
// WEBPACK FOOTER
// ./app/js/globals.js
// module id = 199
// module chunks = 0